/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { Suspense, useState, useRef, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Map } from 'components/map'
import { Candidates } from 'components/candidates'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Scrollchor from 'react-scrollchor'
import { ChipsArray } from 'components/chipsArray'
import { PortraitPicture } from 'components/portraitPicture'
import { Link } from '@ta-interaktiv/contentbricks'
import Button from '@material-ui/core/Button'
import ListIcon from '@material-ui/icons/List'
import { DataGrid } from '@material-ui/data-grid'
import { Autocomplete } from '@material-ui/lab'
import { TextField } from '@material-ui/core'
import { CSSTransition } from 'react-transition-group'
import PersonIcon from '@material-ui/icons/Person'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import GetSheetDone from 'get-sheet-done'
import RotateLeftIcon from '@material-ui/icons/RotateLeft'
import { frFR } from '@material-ui/core/locale'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import domainesProDataVqh from '../../data/domaines-professionnels.csv'
import candidatsDataVqh from '../../data/candidats-data-vqh.csv'
import communesDataVqh from '../../data/communes-data-vqh.csv'
import communes from '../../data/communes.csv'

const ARTICLE_ID = '846053390522'

export function AppComponent() {
  const [filteredCandidates, setFilteredCandidates] = useState([])
  const [municipalityCandidates, setMunicipalityCandidates] = useState([])
  const isMobile = window.innerWidth < 600
  const [
    filteredMunicipalityCandidates,
    setFilteredMunicipalityCandidates
  ] = useState([])
  const [chips, setChips] = useState(['01', '11'])
  const [selectedMunicipality, setSelectedMunicipality] = useState(null)
  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const [communesCandidatesData, setCommunesCandidatesData] = useState([])
  const [showCandidatesList, setShowCandidatesList] = useState(false)
  const [linkedStories, setLinkedStories] = useState([])

  const gotoCommuneInfos = useRef(null)
  const gotoFilteredList = useRef(null)

  // transform the comma separated filters string into an array
  const candidats = candidatsDataVqh.reduce(
    (a, b) => [
      ...a,
      {
        ...b,
        filters: b.filters.split(',')
      }
    ],
    []
  )

  console.log(candidatsDataVqh)
  console.log(candidats)

  const theme = createMuiTheme(
    {
      palette: {
        primary: { main: '#1976d2' }
      }
    },
    frFR
  )

  const handleMunicipalityChange = (e, v) => {
    setSelectedMunicipality(v)
    setMunicipalityCandidates(candidats.filter(c => c.commune === v.nom))
    setTimeout(() => {
      gotoCommuneInfos.current.simulateClick()
    }, 200)
  }

  const autocompleteProps = {
    className: 'commune-selection',
    options: communes,
    getOptionLabel: option => option.nom,
    onChange: handleMunicipalityChange,
    renderInput: params => (
      <TextField {...params} label='Commune' variant='outlined' />
    ),
    autoSelect: true,
    blurOnSelect: true,
    disableClearable: true,
    noOptionsText: 'Aucune commune avec ce nom'
  }

  const handleChips = chips => {
    console.log('FIlTER')
    console.log(chips)
    // Filter the candidates according the user preferences
    const candidatesSlice = candidats.filter(c =>
      chips.every(e => c.filters.includes(e))
    )

    // Count how many filtered candidates per municipality
    const candidatesFilteredCount = candidatesSlice.reduce((acc, cur) => {
      acc[cur.commune_id] = acc[cur.commune_id] + 1 || 1
      return acc
    }, {})

    // Count how many candidates per municipality
    const candidatesCount = candidats.reduce((acc, cur) => {
      acc[cur.commune_id] = acc[cur.commune_id] + 1 || 1
      return acc
    }, {})

    // Find the percentages and create the final array
    const mapData = Object.entries(candidatesFilteredCount).reduce((a, b) => {
      const cdata = communesDataVqh.find(c => c.id === b[0])
      const ccount = candidatesCount[b[0]]

      return [
        ...a,
        {
          id: b[0],
          count: b[1],
          pct: b[1] / ccount
        }
      ]
    }, [])

    setChips(chips)
    setFilteredCandidates(chips.length > 0 ? candidatesSlice : null)
    selectedMunicipality &&
      setFilteredMunicipalityCandidates(
        chips.length > 0
          ? candidatesSlice.filter(
              c => c.commune_id === selectedMunicipality.code
            )
          : null
      )

    console.log('Result - all')
    console.log(candidatesSlice)
    if (selectedMunicipality) {
      console.log('Result', '-', selectedMunicipality.nom)

      console.log(
        chips.length > 0
          ? candidatesSlice.filter(
              c => c.commune_id === selectedMunicipality.code
            )
          : null
      )
    }

    setCommunesCandidatesData(mapData)
  }

  useEffect(() => {
    if (chips.length > 0) {
      handleChips(chips)
    }
  }, [selectedMunicipality])

  useEffect(() => {
    GetSheetDone.labeledCols(
      '15Pvus82UIvJy6AfsQbLX6McOFti4xIV5Nxdyhwk0-KQ',
      1
    ).then(sheet => {
      setLinkedStories(sheet.data.filter(s => s['publié'] === 'TRUE'))
    })
  }, [])

  const columns = isMobile
    ? [
        {
          field: 'fullName',
          headerName: 'Nom',
          description: 'This column has a value getter and is not sortable.',
          sortable: true,
          flex: 1,
          valueGetter: params =>
            `${params.getValue('nom') || ''} ${params.getValue('prénom') || ''}`
        },
        {
          field: 'commune',
          headerName: 'Commune',
          flex: 1
        }
      ]
    : [
        {
          field: 'fullName',
          headerName: 'Nom',
          description: 'This column has a value getter and is not sortable.',
          sortable: true,
          flex: 1,
          valueGetter: params =>
            `${params.getValue('nom') || ''} ${params.getValue('prénom') || ''}`
        },
        {
          field: 'âge',
          headerName: 'Age',
          flex: 1
        },
        {
          field: 'commune',
          headerName: 'Commune',
          flex: 1
        }
      ]

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Les candidats à la Municipalité de votre commune</h1>
            <h2>
              Qui se présente dans votre commune? Quel candidat vous représente
              le mieux? La population de votre commune est-elle suffisamment
              représentée?{' '}
              <Scrollchor className='cbLink cB' to='#find-candidates'>
                Trouvez un candidat
              </Scrollchor>{' '}
              parmi les listes officielles ou partez à la recherche du{' '}
              <Scrollchor className='cbLink cB' to='#candidates-profiler'>
                profil idéal
              </Scrollchor>{' '}
              avec l'aide de notre base de données.
            </h2>
            <div className='ta author'>
              Mathieu Rudaz, Mathieu Signorell, Léa Favre
            </div>
          </div>
        </div>
      </header>

      <div className='ui text container'>
        <p className='ui ta text'>
          Le 7 mars prochain auront lieu, comme tous les cinq ans, les élections
          générales dans les communes vaudoises. La municipalité et le syndic
          seront élus à l'occasion de ce rendez-vous démocratique majeur.
        </p>
        <p className='ui ta text'>
          Nous avons compilé l'ensemble des listes obtenues auprès des
          autorités. Ces informations, parfois acquises avec difficulté, nous
          permettent de dresser le portrait des habitants qui souhaitent se
          mettre au service de leur commune.
        </p>
      </div>

      <div className='find-candidates-container'>
        <div
          className={`ui vertical grey segment ${
            selectedMunicipality ? 'minimized' : ''
          }`}
          style={{ paddingTop: '5em', zIndex: 1, paddingBottom: '4em' }}
          id='find-candidates'
        >
          <Scrollchor ref={gotoCommuneInfos} to='#commune-infos' />
          <div className='ui center aligned text container'>
            <h4 className='ui header dark'>Trouvez vos candidats</h4>
            <div
              className='ui very fitted vertical segment'
              style={{ padding: 0 }}
            >
              <Autocomplete {...autocompleteProps} />
            </div>
          </div>
          <div
            className='ui text container center aligned'
            style={{ paddingTop: '0.75em' }}
          >
            <small>
              Ou explorez notre base de données{' '}
              <i className='ui icon chevron down' />
            </small>
          </div>
        </div>
      </div>
      <Suspense fallback={<div>Chargement</div>}>
        <Candidates
          municipality={selectedMunicipality}
          candidates={municipalityCandidates}
          handleSelectCandidate={candidate => {
            document.body.classList.add('disable_scroll')
            setSelectedCandidate(candidate)
          }}
        />
      </Suspense>

      {selectedMunicipality &&
        linkedStories.filter(s => s.commune === selectedMunicipality.nom)
          .length > 0 && (
          <div className='ui vertical segment'>
            <div className='ui container'>
              <ArticleTeasers
                numberOfCards='three'
                articleIds={linkedStories
                  .filter(s => s.commune === selectedMunicipality.nom)
                  .reduce((a, b) => [...a, b.idarticle], [])}
              />
            </div>
          </div>
        )}

      <div
        className='ui vertical grey segment'
        style={{
          paddingTop: '6em',
          borderTop: '1px solid #eaecef',
          backgroundColor: '#fafbfc'
        }}
      >
        <div className='ui text container'>
          <h4 className='ui header dark'>Tous les profils</h4>
          <p className='ui ta text'>
            Trouvez, selon vos critères, où se présentent les candidats ainsi
            que leur répartition sur l'ensemble du territoire vaudois.
          </p>
          {/* <Link href='https://www.vd.ch/themes/etat-droit-finances/votations-et-elections/elections-communales-generales-2021/?fbclid=IwAR1P4LnNX-A4bUUzXPj89G5DgeTGAJHWrnUdyvVX0g_jUEWZvY0LZX-jyEs'>
            site du canton
                </Link> */}
          <p id='candidates-profiler' className='ui ta text'>
            Ajoutez ou retirez des filtres afin d'obtenir la liste des candidats
            qui correspondent à vos préférences. Une carte permet de visualiser
            la part de ces candidats dans chaque commune. Vous pouvez également
            choisir d'afficher une liste.
          </p>
          <div className='chips-container'>
            <ChipsArray handleChipsChange={handleChips} propchips={chips} />
          </div>
          <div className='chips-result ta text'>
            {filteredCandidates ? (
              filteredCandidates.length > 0 ? (
                <div>
                  {filteredCandidates.length > 0 ? (
                    <div>
                      <b>{filteredCandidates.length}</b> candidat
                      {filteredCandidates.length > 1 ? 's' : ''} (
                      <b>
                        {Math.round(
                          (filteredCandidates.length / candidats.length) * 1000
                        ) / 10}
                        %
                      </b>
                      ) correspond
                      {filteredCandidates.length > 1 ? 'ent' : ''} à ce profil
                      parmi <b>tous les candidats</b> aux municipalités.
                    </div>
                  ) : (
                    <div>
                      Personne ne correspond à ces critères parmi{' '}
                      <b>tous les candidats</b> aux municipalités.
                    </div>
                  )}
                  {selectedMunicipality && (
                    <div>
                      {filteredMunicipalityCandidates.length > 0 ? (
                        <div>
                          <b>{filteredMunicipalityCandidates.length}</b>{' '}
                          candidat
                          {filteredMunicipalityCandidates.length > 1
                            ? 's'
                            : ''}{' '}
                          (
                          <b>
                            {Math.round(
                              (filteredMunicipalityCandidates.length /
                                municipalityCandidates.length) *
                                1000
                            ) / 10}
                            %
                          </b>
                          ) avec ce profil se présente
                          {filteredMunicipalityCandidates.length > 1
                            ? 'nt'
                            : ''}{' '}
                          à la Municipalité{' '}
                          {['a', 'e', 'i', 'o', 'u', 'y'].includes(
                            selectedMunicipality.nom.charAt(0).toLowerCase()
                          )
                            ? "d'"
                            : 'de '}
                          <b>{selectedMunicipality.nom}</b>.
                        </div>
                      ) : (
                        <div>
                          Personne ne correspond à ces critères parmi les
                          candidats à la Municipalité{' '}
                          <b>
                            {['a', 'e', 'i', 'o', 'u', 'y'].includes(
                              selectedMunicipality.nom.charAt(0).toLowerCase()
                            )
                              ? "d'"
                              : 'de '}
                            {selectedMunicipality.nom}
                          </b>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  Ce profil ne figure pas parmi les candidats aux municipalités.
                </div>
              )
            ) : (
              ''
            )}
          </div>
        </div>
        <div className='ui vertical segment' id='filtered-list'>
          <Scrollchor ref={gotoFilteredList} to='#filtered-list' />
          <div className='ui container'>
            {filteredCandidates && filteredCandidates.length > 0 && (
              <>
                {!showCandidatesList ? (
                  <Suspense fallback={<div>Loading</div>}>
                    <Map data={communesCandidatesData} />
                  </Suspense>
                ) : (
                  <div className='candidates-condensed-list-container'>
                    {/*
                <div style={{ display: 'flex', height: '100%' }}>
                  <div style={{ flexGrow: 1 }}>
                    <DataGrid {...data} />
                  </div>
                </div>
                */}
                    <ThemeProvider theme={theme}>
                      <div style={{ height: '650px' }}>
                        <DataGrid
                          disableSelectionOnClick
                          localeText={{
                            columnMenuLabel: 'Menu',
                            columnMenuShowColumns: 'Show columns',
                            columnMenuFilter: 'Filter',
                            columnMenuHideColumn: 'Masquer',
                            columnMenuUnsort: 'Trier',
                            columnMenuSortAsc: 'Trier croissant',
                            columnMenuSortDesc: 'Trier décroissant',
                            filterPanelAddFilter: 'Ajouter un filtre',
                            filterPanelDeleteIconLabel: 'Supprimer',
                            filterPanelOperators: 'Operateurs',
                            filterPanelOperatorAnd: 'Et',
                            filterPanelOperatorOr: 'Ou',
                            filterPanelColumns: 'Colonnes',
                            filterOperatorContains: 'contient',
                            filterOperatorEquals: 'égale à',
                            filterOperatorStartsWith: 'commence par',
                            filterOperatorEndsWith: 'se termine par',
                            filterOperatorIs: 'est',
                            filterOperatorNot: "n'est pas",
                            filterOperatorOnOrAfter: 'est après',
                            filterOperatorBefore: 'est avant',
                            filterOperatorOnOrBefore: 'est après',
                            footerRowSelected: count =>
                              count !== 1
                                ? `${count.toLocaleString()} lignes sélectionnées`
                                : `${count.toLocaleString()} lignes sélectionnées`
                          }}
                          columns={columns}
                          rows={filteredCandidates}
                          pageSize={10}
                          onRowClick={rowParams => {
                            console.log(rowParams.row)
                            setSelectedCandidate(rowParams.row)
                          }}
                        />
                      </div>
                    </ThemeProvider>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className='ui text center aligned container'>
          <Button
            onClick={e => {
              setShowCandidatesList(!showCandidatesList)
              gotoFilteredList.current.simulateClick()
            }}
            variant='contained'
            color='primary'
            disableElevation
            startIcon={<ListIcon />}
          >
            {showCandidatesList ? 'Afficher la carte' : 'Afficher la liste'}
          </Button>
        </div>
      </div>

      <PortraitView
        selectedCandidate={selectedCandidate}
        handleFindOthers={() => {
          console.log('CLICK')
          console.log(selectedCandidate)
          handleChips(selectedCandidate.filters)
        }}
        handleClose={() => {
          setSelectedCandidate(null)
          document.body.classList.remove('disable_scroll')
        }}
      />

      <div className='ui vertical grey-special segment' id='methode'>
        <div
          className='ui ta text container methodik'
          style={{ position: 'relative' }}
        >
          <div className='innerWrapperMethodik'>
            <h4 className='ui header black'>Méthodologie</h4>
            <p>
              Les informations sur les candidats ont été obtenues directement
              auprès de chaque commune vaudoise. Certains candidats ou certaines
              communes ont refusé de nous transmettre des photos ou informations
              relatives à la situation professionnelle.
            </p>

            <p>
              <b>Représentativité des candidats</b>
            </p>

            <p>
              Nous avons comparé l'ensemble des données des candidats de chaque
              commune à sa population pour déterminer si celle-ci était
              correctement représentée. Les{' '}
              <Link href='https://www.bfs.admin.ch/bfs/fr/home/services/geostat/geodonnees-statistique-federale/etablissements-emplois/statistique-structurel-entreprises-statent-depuis-2011.html#:~:text=La%20statistique%20structurelle%20des%20entreprises,paiements%20directs%20(SR%20910.13).'>
                secteurs économiques
              </Link>{' '}
              proviennent de la statistique structurelle des entreprises STATENT
              de l'Office fédéral de la statistique (OFS). Les{' '}
              <Link href='https://www.bfs.admin.ch/bfs/fr/home/statistiques/catalogues-banques-donnees/tableaux.assetdetail.13707294.html'>
                âges
              </Link>
              , de la statistique de la population et des ménages de l'OFS.
            </p>

            <p>
              <b>Orientation politique</b>
            </p>

            <p>
              L'orientation politique de chaque commune est tirée du{' '}
              <Link href='https://www.bfs.admin.ch/bfs/fr/home/statistiques/statistique-regions/portraits-regionaux-chiffres-cles/communes/donnees-explications.html'>
                portrait des communes
              </Link>{' '}
              de l'OFS. Il s'agit de la part des électeurs aux différents partis
              politiques lors de l'élection au Conseil National.
            </p>

            <p>
              <b>Types de conseils et de scrutins</b>
            </p>

            <p>
              Pour tout savoir sur les différents types de Conseils et de
              scrutins, et pour obtenir davantage d'information sur le vote, le
              canton met à disposition{' '}
              <Link href='https://www.vd.ch/themes/etat-droit-finances/communes/pour-ma-commune/municipalite-ou-conseil/'>
                une page
              </Link>{' '}
              dédiée aux élections générales.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui container'>
          <h4 className='ui header'>Plus d'articles sur ce thème</h4>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={linkedStories
              .filter(s => s.commune === '')
              .reduce((a, b) => [...a, b.idarticle], [])}
          />
        </div>
      </div>

      <Footer
        title='Comment jugez-vous ce contenu?'
        questions={[
          'Était-il informatif?',
          'La mise en oeuvre a-t-elle fonctionné?',
          'La mise en forme vous plaît-elle?'
        ]}
        mailTo='mathieu.rudaz@24heures.ch'
        locale='fr'
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        credits={[
          ['Conception et réalisation', 'Mathieu Rudaz'],
          ['Coordination', 'Léa Favre'],
          [
            'Saisie des données',
            'Léa Favre, Mathieu Signorell, Richard, Max, Charlotte, Luca et Léonie'
          ],
          [
            'Photos',
            "Brigitte Besson pour les portraits de Victoria Thibaud, Yves Jauner et Piéric Freiburghaus, Gaia Baur pour le portrait de Jean Christophe Schwaab, Adrien Clerc pour le portrait de Clerc Etienne et Yann Rod pour les candidats à la municipalité d'Yvonand à l'exception du portrait de Mme Frensau"
          ]
        ]}
      />
    </div>
  )
}

const PortraitView = ({ selectedCandidate, handleClose, handleFindOthers }) => {
  const gotoProfiler = useRef(null)
  const todayYear = new Date().getFullYear()

  return (
    <>
      <Scrollchor ref={gotoProfiler} to='#candidates-profiler' />
      <CSSTransition
        unmountOnExit
        in={!!selectedCandidate}
        timeout={200}
        classNames='portrait-view-container'
      >
        <div className='portrait-view-container'>
          <div
            className='dimmer'
            onClick={() => {
              handleClose()
            }}
          />
          <div
            className='portrait-view'
            onClick={() => {
              handleClose()
            }}
          >
            {selectedCandidate && (
              <>
                <div className='candidate-info-panel'>
                  <div className='portrait-header center aligned'>
                    <PortraitPicture
                      id={selectedCandidate.id}
                      genre={selectedCandidate.genre}
                    />
                    <div>
                      <b>
                        {selectedCandidate['prénom']} {selectedCandidate.nom}
                      </b>
                    </div>
                    <div>
                      {selectedCandidate['âge'] !== ''
                        ? `${selectedCandidate['âge']} ans`
                        : 'Na pas voulu'}
                    </div>
                  </div>
                  <div className='portrait-content'>
                    <div>
                      <b>{selectedCandidate.observation}</b>
                    </div>
                    <div>{selectedCandidate.profession}</div>
                    {selectedCandidate.liste !== '' && (
                      <div className='liste'>
                        <b>Liste</b> {selectedCandidate.liste}
                      </div>
                    )}
                    {selectedCandidate.sortant && (
                      <div>
                        <RotateLeftIcon
                          style={{ color: '#202346', fontSize: '1em' }}
                        />
                        Se représente. À la municipalité depuis{' '}
                        <b>{todayYear - selectedCandidate.sortant}</b>
                        &nbsp;ans.
                      </div>
                    )}
                  </div>
                  <div className='portrait-footer'>
                    <Button
                      onClick={() => {
                        handleFindOthers(selectedCandidate)
                        gotoProfiler.current.simulateClick()
                      }}
                      variant='contained'
                      color='primary'
                      disableElevation
                      startIcon={<PersonIcon />}
                    >
                      Profils semblables
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </CSSTransition>
    </>
  )
}
